import * as swcHelpers from '@swc/helpers';
import { parseBloomreachContent, parseBloomreachMeta, getCommonParams } from './helpers/helpers.js';

/**
 * Receives a configuration for a Bloomreach container component
 * and maps it to our own CmsComponentData model
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function useBloomreachData({ page , component  }) {
    const { document: documentRef  } = component.getModels();
    const document = documentRef && page.getContent(documentRef);
    const content = swcHelpers.objectSpread({}, page.isPreview() ? {
        document
    } : {}, parseBloomreachContent(document === null || document === void 0 ? void 0 : document.getData()));
    const meta = parseBloomreachMeta(component.getParameters());
    const common = getCommonParams(meta);
    return {
        ref: documentRef === null || documentRef === void 0 ? void 0 : documentRef.$ref,
        data: swcHelpers.objectSpread({
            meta,
            content
        }, common)
    };
}

export { useBloomreachData };
//# sourceMappingURL=use-bloomreach-data.js.map
